export default "__VITE_ASSET__bee2f8a7__"